import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { UpdateShopInput } from "../../../__generated__/globalTypes";
import { UPDATE_SHOP } from "../shops.queries";
import { parseParams } from "../../../helpers/clean-object";
import {
  UpdateShopMutation,
  UpdateShopMutationVariables,
} from "../../../__generated__/UpdateShopMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
  onError: (msg: string) => any;
}

export const useUpdateShop = ({ id, onCompleted, onError }: IProps) => {
  const form = useForm<UpdateShopInput>({
    mode: "all",
  });

  const [mutate, { loading }] = useMutation<
    UpdateShopMutation,
    UpdateShopMutationVariables
  >(UPDATE_SHOP);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateShop?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateShop?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
      onError(error.message);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
